<template lang="pug">
  #app

    transition(name="fade")
      Loading(v-if="isLoading")

    Header(v-if="!isInGamePage")
    #container(:class="{'is-popup': isPopup}" ref="container")
      Main
      Background
      Particles(v-show="showParticlesWave")
      //- video#particles(playsinline preload muted loop autoplay)
      //-   source(type="video/mp4" src="/videos/wave.mp4")
      //- Promo
      Footer(v-if="!isInGamePage")

    transition(
      name="fade"
      @before-enter="onPopupBeforeEnter"
      @after-enter="onPopupAfterEnter"
      @before-leave="onPopupBeforeLeave"
      @after-leave="onPopupAfterLeave"
    )
      #popup(v-if="popup" :class="[{'popup--ready': isPopupReady}]" ref="popup")
        .popup__container
          PopupMenu(v-if="popup.type === 'menu'")
          PopupRing(v-if="popup.type === 'ring'" :playMusic="playMusic")
          PopupWaiting(v-if="popup.type === 'waiting'")
          PopupScan(v-if="popup.type === 'scan'")

    audio#music(preload="auto" loop="true" ref="audio" style="width: 0; height: 0; visibility: hidden;")
      source(src="/audios/music.mp3" type="audio/mpeg")

</template>

<script>
import axios from 'axios';
import { mapState, mapActions } from 'vuex';
import { mixins } from '@/utils/mixins';

// 預載圖檔 JSON
import preload from '@/json/preload.json';

import Header from './components/Header.vue';
import Loading from './components/Loading.vue';
import Background from './components/Background.vue';
import Particles from './components/Particles.vue';
import Promo from './components/Promo.vue';
import Footer from './components/Footer.vue';

import Main from './containers/Main.vue';

import PopupMenu from './popups/Menu.vue';
import PopupRing from './popups/Ring.vue';
import PopupWaiting from './popups/Waiting.vue';
import PopupScan from './popups/Scan.vue';

export default {
  name: 'App',
  mixins: [mixins],
  computed: {
    ...mapState(['isLoading', 'isMobile', 'popup', 'popupQueue', 'showParticlesWave', 'songData']),
    isInGamePage() {
      return this.$route.path === '/game';
    },
  },
  data: () => {
    return {
      isPopup: false,
      isPopupReady: false,
      isMusicPlayed: false,
    }
  },
  watch: {
    $route(to, from) {
      this.preloadImages(to.path);
    },
    songData(newValue) {
      const { changeMusic } = this;
      console.log('newValue', newValue);
      if (newValue && newValue.Musicmp3) {
        changeMusic(newValue.Musicmp3);
      } else {
        changeMusic('audios/music.mp3');
      }
    },
    // jumpTarget(to, from) {
    //   if (!to, from) return;
    //   this.trackPageview(to)
    // },
  },
  methods: {
    ...mapActions(['toggleLoading', 'toggleMobile', 'openPopup', 'closePopup', 'clearPopupQueue']),
    setCssVariable() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    checkIsMobile() {
      const { toggleMobile } = this;
      toggleMobile(window.matchMedia('(max-width: 1080px)').matches);
    },
    checkIsPopupMenuOpened() {
      const { isMobile, closePopup } = this;
      const { popup } = this;
      if (!isMobile && popup && popup.type === 'menu') closePopup();
    },
    checkIsPopupScanOpened() {
      const { isMobile, closePopup } = this;
      const { popup } = this;
      if (isMobile && popup && popup.type === 'scan') closePopup();
    },
    onResize() {
      const { setCssVariable, checkIsMobile, checkIsPopupMenuOpened, checkIsPopupScanOpened } = this;
      setCssVariable();
      checkIsMobile();
      checkIsPopupMenuOpened();
      checkIsPopupScanOpened();
    },
    onPopupBeforeEnter() {
      const { popupQueue, clearPopupQueue } = this;
      const { container } = this.$refs;
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || 0;
      this.isPopup = true;
      container.style.top = -scrollTop + 'px';
      window.scrollTo(0, 0)
      if (popupQueue) clearPopupQueue();
    },
    onPopupAfterEnter() {
      this.isPopupReady = true;
      // const popup = document.querySelector('#popup')
      // popup.classList.add('popup--ready');
    },
    onPopupBeforeLeave() {
      this.isPopupReady = false;
      // this.$refs.popup.classList.remove('popup--ready'); // 77在測試
      // const popup = document.querySelector('#popup')
      // popup.classList.remove('popup--ready');
    },
    onPopupAfterLeave() {
      const { popupQueue, openPopup } = this;
      const { container } = this.$refs;
      const containerTop = Math.abs(parseInt(container.style.top));
      this.isPopup = false;
      this.isPopupReady = false;
      container.style.top = 0 + 'px';
      this.$nextTick(() => {
        window.scrollTo(0, containerTop)
        if (popupQueue) openPopup({ type: popupQueue })
      })
    },
    // trackPageview(elem) {
    //   let pv = elem.dataset.pv;
    //   this.$trackPage(pv)
    // }
    initMusic() {
      const { isMusicPlayed } = this;
      const { audio } = this.$refs;
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          audio.pause();
        } else {
          if (this.isMusicPlayed) audio.play();
        }
      })
    },
    playMusic() {
      const { isMusicPlayed } = this;
      const { audio } = this.$refs;
      audio.play();
      if (!isMusicPlayed) this.isMusicPlayed = true;
    },
    changeMusic(url) {
      const { audio } = this.$refs;
      audio.src = '/' + url.replace(/\\/g, '/');
      audio.load();
      audio.play();
    },
    preloadImages(key) {
      const preloadArray = preload[key];
      if (preloadArray) {
        preloadArray.forEach(item => {
          const image = new Image;
          image.src = require(`@/assets/images/${item}`);
        })
      }
    },
  },
  created() {

    const { onResize, toggleLoading } = this;
    window.addEventListener('resize', onResize);

    window.addEventListener('load', () => {
      setTimeout(() => { toggleLoading(false) }, 250)
    })

    document.body.addEventListener('touchstart', function() {}, false)

    // document.body.addEventListener('touchstart', function() {}, false);

    // if (!this.isDev()) this.$router.push('/').catch(err => {err});

    // const lenis = new Lenis()

    // lenis.on('scroll', (e) => {
    //   console.log(e)
    // })

    // function raf(time) {
    //   lenis.raf(time)
    //   requestAnimationFrame(raf)
    // }

    // requestAnimationFrame(raf)

  },
  mounted() {

    const {
      setCssVariable,
      checkIsMobile,
      preloadImages,
      initMusic,
    } = this;

    setCssVariable();
    checkIsMobile();
    preloadImages(this.$route.path);
    initMusic();

    // if (this.isMobile) this.openPopup({ type: 'ring' })

  },
  components: {
    Header,
    Main,
    Background,
    Particles,
    Loading,
    Promo,
    Footer,
    PopupMenu,
    PopupRing,
    PopupWaiting,
    PopupScan,
  }
}

</script>

<style lang="scss">

:root {
  --move-y: 50px;
  --header-height: #{vhX(135)};
  @include tablet {
    --move-y: #{vw(50)};
    --header-height: #{vw(100)};
  }
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  @include tablet {
  }
}

#container {
  position: relative;
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  @include tablet {
  }
  &.is-popup {
    position: fixed;
  }
}

.disabled {
  position: relative;
  a {
    opacity: 0.2;
    pointer-events: none;
  }
}

input[type="text"],
textarea,
select,
button {
  font-family: $fontFamilyNotoSans;
  font-weight: 500;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  outline: 0;
  appearance: none;
}

textarea {
  resize: none;
}

select {
  // height: vwXL(70);
  // color: #eb623c;
  // font-size: vwXL(27);
  // font-weight: 700;
  // letter-spacing: vwXL(letterSpacing(50, 27));
  // padding-right: vwXL(70);
  // padding-bottom: vwXL(2);
  // padding-left: vwXL(15);
  // border: #f8e577 vwXL(4) solid;
  // background: url('~@/assets/images/common/dropdowns_arrow.png') right vwXL(17) top vwXL(20) #fff no-repeat;
  // background-size: vwXL(49) vwXL(25);
  // cursor: pointer;

  @include tablet {
    // height: vwM(70);
    // font-size: vwM(40);
    // letter-spacing: vwM(letterSpacing(50, 40));
    // padding-right: vwM(0);
    // padding-bottom: vwM(2);
    // padding-left: vwM(25);
    // border-width: vwM(4);
    // background-position: right vwM(16) top vwM(20);
    // background-size: vwM(49) vwM(25);
  }
}

// button {
//   height: vwXL(70);
//   color: #eb623c;
//   font-size: vwXL(27);
//   font-weight: 700;
//   letter-spacing: vwXL(letterSpacing(50, 27));
//   padding-right: vwXL(22);
//   padding-bottom: vwXL(2);
//   padding-left: vwXL(24);
//   background: #f8e577;
//   cursor: pointer;

//   @include tablet {
//     height: vwM(70);
//     font-size: vwM(36);
//     letter-spacing: vwM(letterSpacing(50, 36));
//     padding-right: vwM(0);
//     padding-bottom: vwM(2);
//     padding-left: vwM(0);
//   }
// }

::placeholder {
  color: #999999;
  opacity: 1;
}

:-ms-input-placeholder {
  color: #999999;
}

::-ms-input-placeholder {
  color: #999999;
}

#popup {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  // min-height: 100%;
  min-height: calc(var(--vh, 1vh) * 100);
  z-index: 2;

  &.fade-leave-active {}

}

.popup__container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: auto;
  // min-height: 100%;
  min-height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
  // background: rgba(#fff, 0.7);
  background: rgba(#000, 0.9);

  @include tablet {}

}

.popup__main {
  display: flex;
  flex-direction: column;
  position: relative;
  color: #fff;
  margin: vwXL(100) 0;
  @include tablet {
    margin: vwM(100) 0;
  }
}

.popup__basic {
  width: vwXL(1175);
  min-height: vwXL(588);
  background: #fdf2ef;

  @include tablet {
    width: vwM(884);
    height: auto;
    // height: calc(var(--vh, 1vh) * 100 - vwM(170 * 2));
    min-height: 0;
    // min-height: vwM(900);
    margin: vwM(170) 0;
  }

  &--full {
    @include tablet {
      // min-height: calc(var(--vh, 1vh) * 100 - vwM(170 * 2));
      height: calc(var(--vh, 1vh) * 100 - vwM(170 * 2));
      min-height: vwM(900);
    }
  }

  .popup__content {
    color: #eb623c;
    padding: 0 vwXL(80);

    @include tablet {
      padding: 0 vwM(74);
    }
  }

  .popup__title {

    display: flex;
    align-items: center;
    justify-content: center;

    padding: vwXL(60) 0 0;

    @include tablet {
      padding: vwM(78) 0 0;
    }

    p {
      color: #e72910;
      font-size: vwXL(47);
      font-weight: 700;
      text-align: center;
      letter-spacing: vwXL(letterSpacing(50, 47));
      transform: scaleX(1.05);

      @include tablet {
        font-size: vwM(68);
        letter-spacing: vwM(letterSpacing(50, 68));
      }
    }

  }
}

.popup__header {
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.popup__close {
  position: absolute;
  top: 0;
  right: 0;
  width: vwXL(78);
  height: vwXL(78);
  // background: url('~@/assets/images/common/popup_close.png') center center no-repeat;
  background-size: contain;
  z-index: 1;

  @include tablet {
    width: vwM(68);
    height: vwM(68);
  }
}

// .popup__main .popup__content {
.popup__main {
  opacity: 0;
  transform: translateY(vwM(100));
  transition: all .5s ease;
  transition-property: opacity, transform;
  @include desktop {
    opacity: 1;
    transform: translateY(0);
  }
}

// #popup.popup--ready .popup__main .popup__content {
#popup.popup--ready .popup__main {
  opacity: 1;
  transform: translateY(0);
}

.move-in {
  @include moveFadeDefault($value: var(--move-y));
  @at-root .section.play .move-in {
    @include moveFadeIn();
  }
}

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: $primaryDuration;
  transition-timing-function: ease;
}

.fade-enter-active {
  transition-delay: 0s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

</style>
